import React, { useEffect } from 'react';
import { reportProps } from './StopLossAggregateTable';
import {
  CardComponent,
  PieChartWithoutCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import enrollmentMetricsMessages from '../core-utils/messages/enrollmentMetricsMessages';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Box, Grid } from '@mui/material';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

const MedicalVsRxPlanPaid: React.FC<reportProps> = ({ data }) => {
  const getData = (type: string) => {
    let employeeRx: number = 0;
    let employeeMed: number = 0;
    let dependentRx: number = 0;
    let dependentMed: number = 0;
    const chartData = [
      {
        label: 'Rx',
        value: 0,
        color: patientAccessTheme.palette.primary[300],
      },
      {
        label: 'Medical',
        value: 0,
        color: patientAccessTheme.palette.warning[500],
      },
    ];

    data?.employeeDependentPlanPaid?.map((curr: any) => {
      if (curr.member_role === 'Employee') {
        employeeRx = curr.total_rx_spend;
        employeeMed = curr.total_med_spend;
      } else if (curr.member_role === 'Dependent') {
        dependentRx = curr.total_rx_spend;
        dependentMed = curr.total_med_spend;
      }
    }, {});
    if (type === 'total') {
      chartData[0].value = employeeRx + dependentRx;
      chartData[1].value = employeeMed + dependentMed;
    }
    if (type === 'employee') {
      chartData[0].value = employeeRx;
      chartData[1].value = employeeMed;
    }
    if (type === 'dependent') {
      chartData[0].value = dependentRx;
      chartData[1].value = dependentMed;
    }
    return chartData;
  };

  const legend: any = [
    { color: patientAccessTheme.palette.primary[300], value: 'Rx' },
    {
      color: patientAccessTheme.palette.warning[500],
      value: 'Medical',
    },
  ];

  const getLegend = (item: any) => {
    return (
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          margin: '0px 24px 0px 0px',
        }}
      >
        <Grid
          style={{
            backgroundColor: item.color,
            height: '8px',
            width: '8px',
            borderRadius: '2px',
            marginRight: '8px',
          }}
        ></Grid>
        <Grid>
          <Box>
            <Typography
              style={{
                fontSize: '12px',
                lineHeight: '24px',
                fontWeight: 'normal',
                color: patientAccessTheme.palette.text.mediumemphasis,
              }}
            >
              {item.value}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    );
  };
  useEffect(() => {}, []);
  return (
    <CardComponent
      title={enrollmentMetricsMessages.cardText.medicalVsRx}
      height="300px"
      width="70%"
      body={
        <>
          <Grid style={{ display: 'flex' }}>
            <PieChartWithoutCard
              data={getData('total')}
              showLegend={false}
              showValues={true}
              chartName="Total Plan Spend"
              cardHeight="190px"
              addPrefix
              pieRadius="45%"
            />

            <PieChartWithoutCard
              data={getData('employee')}
              showLegend={false}
              showValues={true}
              chartName="Employee Plan Spend"
              cardHeight="190px"
              addPrefix
              pieRadius="45%"
            />
            <PieChartWithoutCard
              data={getData('dependent')}
              showLegend={false}
              showValues={true}
              chartName="Dependent Plan Spend"
              cardHeight="190px"
              addPrefix
              pieRadius="45%"
            />
          </Grid>
          <Grid
            container
            style={{ justifyContent: 'center', margin: '10px 0px 0px 25px' }}
          >
            {legend.map((item: any) => getLegend(item))}
          </Grid>
        </>
      }
    />
  );
};
export default MedicalVsRxPlanPaid;
